export function PageHeader() {
  return (
    <div>
      <h1 className='text-[1.5rem] md:text-[2.5rem] lg:text-[4rem] font-bold text-black mb-2.5 leading-[120%]'>
        Contact ClovisClassics.com
      </h1>
      <p className='font-semibold md:text-lg '>Have a question about ClovisClassics.com?</p>
    </div>
  );
}
